import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../components/home.vue'
import Index from '../components/index.vue'
import Feature from '../components/feature.vue'
import Release from '../components/release.vue'
import Voc from '../components/voiceofcustomer.vue'
import Download from '../components/download.vue'
import Link from '../components/link.vue'
import Contact from '../components/contact.vue'
import Register from '../components/register.vue'
import Query from '../components/query.vue'
import globalConst from '../components/globalConst.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/index',
      children: [
        {
          path: '/index',
          component: Index
        },
        {
          path: '/feature',
          component: Feature
        },
        {
          path: '/release',
          component: Release
        },
        {
          path: '/voiceofcustomer',
          component: Voc
        },
        {
          path: '/download',
          component: Download
        },
        {
          path: '/link',
          component: Link
        },
        {
          path: '/contact',
          component: Contact
        },
        {
          path: '/register',
          component: Register
        },
        {
          path: '/query',
          component: Query
        }
      ]
    }
  ]
})

Vue.prototype.$globalConst = globalConst
export default router
